import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'genericMetricFormatter'
})
export class GenericMetricFormatterPipe implements PipeTransform {

  transform(value: number, conversionType: string): string {
    let formatted: string = "";
    const _value = value || 0;

    switch (conversionType) {
      case "1": //Second
        formatted = _value.toString();
        break;
      case "2": //Minute
        formatted = (_value / 60).toString();
        break;
      case "3": //Hour
        formatted = (Math.floor((_value / 3600) * 100) / 100).toString();
        break;
      case "4": //Time      
        var hours = parseInt(Math.floor(_value / 3600).toString());
        var minutes = parseInt(Math.floor((_value - (hours * 3600)) / 60).toString());
        var seconds = parseInt((_value - (hours * 3600) - (minutes * 60)).toString());

        var strHour = hours < 10 ? ("0" + hours) : hours;
        var strMinutes = minutes < 10 ? ("0" + minutes) : minutes;
        var strSecond = seconds < 10 ? ("0" + seconds) : seconds;

        formatted = strHour + ':' + strMinutes + ':' + strSecond;
        break;
      case "5": //Percent
        formatted = (_value*100).toFixed(2);
        break;
      default:
        formatted = (_value % 1 == 0) ? _value.toString() : _value.toFixed(2);
        break;
    }

    return formatted;
  }
}
